import { render, staticRenderFns } from "./RemoveContent.vue?vue&type=template&id=501b4314&"
import script from "./RemoveContent.vue?vue&type=script&lang=js&"
export * from "./RemoveContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports